<template>
  <div class="dashboard">
    <Loader :loading="loading" loading-text="please wait..." />
    <main class="page-content">
      <header class="welcome-text mb-3 ml-2 ml-lg-0">
        <span class="transfer-option"></span>
      </header>

      <div class="statement-container">
        <!-- back-home -->
        <div class="back-home" style="cursor:pointer" @click="$router.go(-1)">
          <span>
            <i class="fal fa-long-arrow-left icon"></i>
          </span>
          <!-- <span><i class="fal fa-arrow-left icon fa-2x"></i></span> -->
        </div>

        <!-- form start -->
        

        <div class="mt-5">
          <ValidationObserver v-slot="{ passes }">
            <form @submit.prevent="passes(createAccount)">
              <div class="containe">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <!-- title -->
                      <div class="form-group col-md-6 col-sm-12">
                        <ValidationProvider
                          name="titleCustomer"
                          rules="required"
                          ref="title"
                          v-slot="{ errors }"
                        >
                          <label for="title">
                            Title
                            <span class="text-danger">*</span>
                          </label>

                          <select
                          disabled
                            v-model="titleCustomer"
                            type="text"
                            name="title"
                            class="browser-default custom-select mb-sm-0"
                            id="title"
                          >
                            <option value="Employed">MR</option>
                            <option value="Self-Employed">MRS</option>
                            <option value="Unemployed">MS</option>
                          </select>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>

                      <!--  Name -->
                      <div class="div3i col-md-6 mb-3">
                        <!-- <ValidationProvider
                          name="nameGuarantor"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Name
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="nameGuarantor"
                              class="form-control"
                              placeholder
                              name="name"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider> -->
                      </div>
                      <!-- firstname -->
                    </div>
                     <div class="row">
                      <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="firstnameCustomer"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            First Name
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                            disabled
                              type="text"
                              v-model="firstnameCustomer"
                              class="form-control"
                              placeholder
                              name="firstname"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <!-- lastname -->
                      <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="lastnameCustomer"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Last Name
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                            disabled
                              type="text"
                              v-model="lastnameCustomer"
                              class="form-control"
                              placeholder
                              name="lastname"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>

                    <!-- Phone Number -->
                    <!-- <div class="row">
                      <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="phoneGuarantor"
                          rules="required|min:11"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Phone Number
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                              type="number"
                              v-model="phoneGuarantor"
                              class="form-control"
                              placeholder
                              name="phone"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div> -->
                      <!-- Address -->
                      <!-- <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="addressGuarantor"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Address
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="addressGuarantor"
                              class="form-control"
                              placeholder
                              name="name"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>  -->
                    <!-- Email -->
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="emailCustomer"
                          rules="required|email"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Email
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                            disabled
                              type="email"
                              v-model="emailCustomer"
                              class="form-control"
                              placeholder
                              name="email"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <!-- phonenumber -->
                     <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="phoneCustomer"
                          rules="required|min:11"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Phone Number
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                            disabled
                              type="number"
                              v-model="phoneCustomer"
                              class="form-control"
                              placeholder
                              name="phone"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <!--dob -->

                      <div class="form-group col-md-6 col-sm-12">
                        <ValidationProvider name="dobCustomer" rules>
                                <label for>
                                  Date of Birth
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <datetime
                                  disabled
                                    v-model="dobCustomer"
                                    class
                                    placeholder=" -DD-MM-YY-"
                                  ></datetime>
                                  <div class="input-group-append">
                                    <span
                                      class="input-group-text"
                                      style="height:30px"
                                    >
                                      <i
                                        class="fa fa-calendar-check"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </div>
                                </div>
                                <span
                                  v-if="error"
                                  style="font-size:13px; color:red"
                                >
                                  <span>
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  This field is required
                                </span>
                              </ValidationProvider>
                      </div>
                      <!-- Current Address -->
                      <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="addressCustomer"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="employeraddress">Current Address</label>
                          <input
                          disabled
                            v-model="addressCustomer"
                            name="address"
                            type="text"
                            class="form-control"
                            id="address"
                          />
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>

                        <!-- City -->

                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="cityCustomer"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            City
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                            disabled
                              type="text"
                              v-model="cityCustomer"
                              class="form-control"
                              placeholder
                              name="city"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <!-- country -->
                      <div class="col-md-6 mb-3">
                        <ValidationProvider
                          name="countryCustomer"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Country
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                            disabled
                              type="text"
                              v-model="countryCustomer"
                              class="form-control"
                              placeholder
                              name="country"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>

                    

                    <!-- <div class="btn btn-info float-right">submit</div> -->
                  </div>

                  <!-- Image uploads -->
                  <!-- <div class="col-md-4"> -->
                    <!-- <div class="row">
                      <div class="col-md-3"></div>
                      <div class="col-md-7">
                        <div class="div1 mb-3">
                          <span class="mt-md-n4 mb-md-3">
                            ID Attachment
                            <span class="text-danger">*</span>
                          </span>
                          <div class="mb-2 mb-md-0 uploads" style="height:130px">
                            <img class="img-fluid" :src="idCard" alt />
                          </div>
                          <span style="font-size:13px; color:red">maximum file size : 2mb</span>

                          <div class="input-group mt-2">
                            <ValidationProvider name="idCard" v-slot="{ validate, errors }">
                              <label class="btn ml-1 btn-primary btn-file">
                                BROWSE
                                <input
                                  type="file"
                                  class="mt-3 mt-md-0 mb-2 mb-md-1 d-none"
                                  @change="
                                      onFileChange1($event);
                                      validate($event);
                                    "
                                  name="idCard"
                                  id="id"
                                />
                              </label>
                              <br />
                              <span style="font-size:13px; color:red">
                                <span v-if="errors[0]">
                                  <i class="fas fa-ban"></i>
                                </span>
                                {{ errors[0] }}
                              </span>
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="div2">
                          <span class="mt-md-n4 mb-md-3">
                            Passport
                            <span class="text-danger">*</span>
                          </span>
                          <div class="mb-2 mb-md-0 uploads" style="height:130px">
                            <img class="img-fluid" :src="passport" alt />
                          </div>
                          <span style="font-size:13px; color:red">maximum file size : 2mb</span>

                          <div class="input-group mr-2 mt-2">
                            <ValidationProvider name="signature" v-slot="{ validate, errors }">
                              <label class="btn ml-1 btn-primary btn-file">
                                BROWSE
                                <input
                                  type="file"
                                  class="mt-3 mt-md-0 mb-2 mb-md-1 small-screen-id"
                                  @change="
                                      onFileChange2($event);
                                      validate($event);
                                    "
                                  style="display:none"
                                  name="signature"
                                  id="signature"
                                />
                              </label>
                              <br />
                              <span style="font-size:13px; color:red">
                                <span v-if="errors[0]">
                                  <i class="fas fa-ban"></i>
                                </span>
                                {{ errors[0] }}
                              </span>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  <!-- </div> -->
                </div>

                <div class="submit-btn">
                  <b-button
                    type="submit"
                    class="btn mt-3 text-center mr-1 btn-primary"
                    @click="$router.push('/Cso/Loan/Applyloan')"
                  >Continue</b-button>
                </div>
                <div class="line"></div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
//import VueNumeric from "vue-numeric";
import { clientService } from "../../../services/ClientServices/client.services";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "../../../utils/vue-loader/loader.vue";
//import { mapState } from "vuex";
export default {
  name: "Apply",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loader
    //VueNumeric
  },
  data() {
    return {
      titleCustomer: "",
      firstnameCustomer: "",
      lastnameCustomer: "",
      phoneCustomer: "",
      dobCustmer: "",
      addressCustomer: "",
      cityCustomer: "",
      countryCustomer: "",
      
    };
  },
  methods: {
    minus() {
      if (this.tenor <= 0) return;
      this.tenor = this.tenor - 1;
    },
    plus() {
      if (this.tenor >= 6) return;
      this.tenor = this.tenor + 1;
    },
    //Post Loan
    async postLoan() {
      this.loading = true;
      await clientService
        .postLoan({
          amount: this.amount,
          tenor: this.tenor,
          account: this.account,
          purpose: this.loanPurpose,
          bank: this.bank
        })
        .then(res => {
          this.$toastr.s(res.message, "Posted Succesfully");
          this.$router.push("/Loan");
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-primary {
  background: $main-color;
  border: 1px solid $main-color;
  font-family: $SourceSansPro-Regular;
  width: 100px;
}

.uploads {
  border: 1px solid rgb(78, 78, 78);
}

.current {
  background: $main-color;
}

.back-home {
  width: 170px;
}
</style>
